import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=1d8df916&"
import script from "./Question.vue?vue&type=script&lang=js&"
export * from "./Question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d8df916')) {
      api.createRecord('1d8df916', component.options)
    } else {
      api.reload('1d8df916', component.options)
    }
    module.hot.accept("./Question.vue?vue&type=template&id=1d8df916&", function () {
      api.rerender('1d8df916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Question.vue"
export default component.exports